import { __decorate } from "tslib";
import { field } from '@simonbackx/simple-encoding';
import { MemberWithRegistrationsBlob } from './MemberWithRegistrationsBlob.js';
import { Registration } from './Registration.js';
export class RegistrationWithMemberBlob extends Registration {
    member;
}
__decorate([
    field({ decoder: MemberWithRegistrationsBlob })
], RegistrationWithMemberBlob.prototype, "member", void 0);
//# sourceMappingURL=RegistrationWithMemberBlob.js.map